module.exports = __webpack_public_path__ + "static/media/flip.e1588823.png";